import React, { useEffect, useRef } from "react";
import "./HomeBanner.css";
import homeBannerImg from "../../../Images/HomeBanner.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import bannerlogo from "./banner.json";
import Lottie from "lottie-react";
import Typed from "react-typed";

// import animationData from "../../../../public/banner.json";
// import Lottie from "lottie-web";

const HomeBanner = () => {
  //   const defaultOptions = {
  //     loop: true,
  //     autoplay: true,
  //     animationData: animationData,
  //   };

  return (
    <div className="banner-div-full">
      <container className="container">
        <div className="banner-div">
          {/* <div>
            <img className="banner-img" src={homeBannerImg} alt="" />
          </div> */}
          <div className="lottie-1-div">
            <Lottie
              animationData={bannerlogo}
              loop={true}
              className="lottie-1"
            />
          </div>

          <div className=" banner-text-div">
            <h1 className="h1-banner">
              We help to make your life better <br /> by our{" "}
              <span style={{ color: "#27559e" }}>
                <Typed
                  data-aos="zoom-out-up"
                  className="strings-texts"
                  strings={["INNOVATION", "IDEAS", "PLANNING"]}
                  typeSpeed={80}
                  backSpeed={70}
                  loop
                />
              </span>
            </h1>
            <p className="p-banner">
              "Innovation is the ability to see change as an opportunity – not a
              threat."
              <br /> - Steve Case
            </p>

            <div>
              <form className="mt-4 input-button">
                <div className=" ">
                  <input
                    type="text"
                    className="form-control"
                    id="inputText"
                    placeholder="enter the service"
                  />
                </div>
                <div className="">
                  <button type="submit" className="btn banner-search">
                    <span>
                      {"   "}{"   "}
                      <FontAwesomeIcon icon={faSearch} />
                    </span>
                    Search
                  </button>
                </div>
              </form>
            </div>
            <div className="home-buttons">
              <form className="d-flex align-items-center justify-content-center banner-button">
                <button className=" me-2 h-b-button1" type="submit">
                  Request for Question
                </button>
                <button className=" h-b-button2" type="submit">
                  Get Demo
                </button>
              </form>
            </div>
          </div>
        </div>
      </container>
    </div>
  );
};

export default HomeBanner;
